export default __webpack_public_path__ + "static/media/vijaywadaTempleThree.5ee10706.png";